import * as React from 'react';
import styles from '../Shared/SubjectDescription.module.css';
import type { SubjectContentTranslations } from '~/Pages/SubjectInfoPage/SubjectContentTranslations.csharp';
import type { SubjectInfoDescriptionViewModel } from '~/Pages/SubjectInfoPage/SubjectInfoDescriptionViewModel.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';

export interface SubjectDataProps {
    subjectInfoDescription: SubjectInfoDescriptionViewModel;
    translations: SubjectContentTranslations;
}

export const SubjectData: React.FC<SubjectDataProps> = props => {
    const { subjectInfoDescription, translations } = props;

    return (
        <>
            {subjectInfoDescription.semesterInformation && (
                <li>
                    <h3>{translations.semester}</h3>
                    <span>
                        <HtmlDiv className={styles.ClearText} html={subjectInfoDescription.semesterInformation} />
                    </span>
                </li>
            )}
            {!!subjectInfoDescription.numberOfSemester && (
                <li>
                    <h3>{translations.numberOfSemesters}</h3>
                    <span>{subjectInfoDescription.numberOfSemester}</span>
                </li>
            )}
            {!!subjectInfoDescription.subjectCoordinators && (
                <li>
                    <h3>{translations.subjectCoordinator}</h3>
                    <span>{subjectInfoDescription.subjectCoordinators}</span>
                </li>
            )}
            {!!subjectInfoDescription.subjectTeachingLanguage && (
                <li>
                    <h3>{translations.teachingLanguage}</h3>
                    <span>{subjectInfoDescription.subjectTeachingLanguage}</span>
                </li>
            )}

            {!!subjectInfoDescription.decision && (
                <li>
                    <h3>{translations.decision}</h3>
                    <span>
                        <HtmlDiv className={styles.ClearText} html={subjectInfoDescription.decision} />
                    </span>
                </li>
            )}
        </>
    );
};
